import React, { useState, useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import { MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import Box from '@mui/material/Box';

import { useHistory } from "react-router-dom";
import moment from 'moment';
import { parse, format } from 'date-fns';
import Chip from '@mui/material/Chip';
import Rating from '@mui/material/Rating';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';

import api from '../../../../../../services/api';
import MenuRecursosFrota from '../components/menu';
import NavegadorGestao from "../../../../../../components/NavBarGestao";
import AnexadorArquivos from "../../../../../../components/AnexadorArquivos";


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
}));



export default function CadastrarAdvertencia({ flag, advertenciaAtualizar, veiculo, ocorrencias , closeNovaAdvertencia,listarAdvertencias }) {

    
   const [idAdvertenciaSalva, setIdAdvertenciaSalva] = useState(flag === 0 ? 0 : advertenciaAtualizar.id_advertencia);
     const anexadorRef = useRef();

    const classes = useStyles();
    const history = useHistory();

    const [tipoAdvertencia, setTipoAdvertencia] = useState(flag === 0 ? 0 : advertenciaAtualizar.tipo_advertencia);
    const [descricao, setDescricao] =  useState(flag === 0 ? "" : advertenciaAtualizar.descricao_advertencia);

    const [dataAdvertencia, setDataAdvertencia] =  useState(flag === 0 ? "" : advertenciaAtualizar.data_advertencia);
    const [horaAdvertencia, setHoraAdvertencia] =  useState(flag === 0 ? "" : advertenciaAtualizar.hora_advertencia);
    const [valor, setValor] =  useState(flag === 0 ? 0.0 : advertenciaAtualizar.valor);


    const [colaboradores, setColaboradores] = useState([]);
    const [colaboradorSelecionado, setColaboradorSelecionado] =  useState(flag === 0 ? null : advertenciaAtualizar.responsavel);

    const [loading, setLoading] = useState(true);


    const [ocorrenciasFiltradas, setOcorrenciasFiltradas] = useState([]);            


    const [ocorrenciasSelecionadas, setOcorrenciasSelecionadas] =  useState(flag === 0 ? [] : advertenciaAtualizar.ocorrencias);


    const handleAdicionarOcorrencia = (event, newValue) => {
        // Verifica se o valor selecionado já está na lista
        const valoresSelecionados = Array.isArray(newValue) ? newValue : [newValue];
        const novasOcorrencias = valoresSelecionados.filter(
            (opcao) => !ocorrenciasSelecionadas.some((selecionado) => selecionado.id_ocorrencia === opcao.id_ocorrencia)
        );

        setOcorrenciasSelecionadas([...ocorrenciasSelecionadas, ...novasOcorrencias]);
    };



    const handleRemoverOcorrencia = (event, ocorrenciaRemovida) => {
        // alert("Handle remover dep chamado")
        const novasOcorrencias = ocorrenciasSelecionadas.filter(
            (oc) => oc.id_ocorrencia !== ocorrenciaRemovida.id_ocorrencia
        );
        setOcorrenciasSelecionadas(novasOcorrencias);
    };



 


    const [rastreamentosSelecionados, setRastreamentosSelecionados] = 
    useState(flag === 0 ? [] : advertenciaAtualizar.rastreamentos);


    // Adicionar tipo de manutenção
    const handleAdicionarRastreamento = (event, newValue) => {
        const valoresSelecionados = Array.isArray(newValue) ? newValue : [newValue];

        const novosRastreamentos = valoresSelecionados.filter(
            (opcao) => !rastreamentosSelecionados.some(
                (selecionado) => selecionado.id_rastreamento === opcao.id_rastreamento
            )
        );

        setRastreamentosSelecionados([...rastreamentosSelecionados, ...novosRastreamentos]);
    };

    // Remover tipo de manutenção
    const handleRemoverRastreamento = (event, rastreamentoRemovido) => {
        const novosRastreamentos = rastreamentosSelecionados.filter(
            (ras) => ras.id_rastreamento !== rastreamentoRemovido.id_rastreamento
        );

        setRastreamentosSelecionados(novosRastreamentos);
    };
    async function listarInformacoes() {

        setLoading(true);

        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }



            await api.get("v1/protected/colaboradores/listartodos", {
                headers: headers
            }).then(function (response) {
                setColaboradores(response.data)

                    setLoading(false);



            });


        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar os Solicitantes: " + _err)

        }

    }


    useEffect(() => {
        listarInformacoes();

    }, []);



    function returnDescricaoColaborador(colaborador) {


        var texto = "Colaborador_ID: " + colaborador.id_colaborador +
            "\nCPF: " + colaborador.cpf +
            "\nNome: " + colaborador.nome + " " + colaborador.sobrenome + "\n ";
        return texto;
    }


  function returnDescricaoOcorrenciaSimplificada(ocorrencia) {
    // supondo que venham como array
    const [yyyy, mm, dd] = ocorrencia.data_ocorrencia;   // [2025, 8, 16]
    const [hh, mi, ss] = ocorrencia.hora_ocorrencia;     // [14, 35, 22]

    // formata com zero à esquerda
    const dataFormatada = `${String(dd).padStart(2, "0")}/${String(mm).padStart(2, "0")}/${yyyy}`;
    const horaFormatada = `${String(hh).padStart(2, "0")}:${String(mi).padStart(2, "0")}`;

    var texto = `ID: ${ocorrencia.id_ocorrencia} ${ocorrencia.descricao_ocorrencia} em
${dataFormatada} ${horaFormatada}`;

    return texto;
}



  function returnDescricaoRastreamentoSimplificado(rastreamento) {
    
    var texto = "ID: " + rastreamento.id_rastreamento + " | " + 
    (rastreamento.alta_velocidade === 1 ? " Excesso de Velocidade | " : "" ) + 
        (rastreamento.fora_horario === 1 ? " Fora de Horario | " : "" ) +
        (rastreamento.fim_semanda === 1 ? " Viagem em Fim de Semana | " : "") +  
     rastreamento.viagem;

    return texto;
}
 
    const [nota, setNota] =  useState(flag === 0 ? 2 : advertenciaAtualizar.nota);


const handleSelecionarColaborador = (v) => {
    setColaboradorSelecionado(v);

    // Filtra as ocorrências pelo responsavel_id
    const filtradas = ocorrencias.filter(
        (o) => o.responsavel.id_colaborador === v.id_colaborador
    );

    setOcorrenciasFiltradas(filtradas);
};


    const handleChangeStart = (event, newValue) => {
        console.log("nota: " + newValue);
        if (!newValue)
            newValue = nota;
        setNota(newValue); // Deselect if clicking on the selected star again
     };

     const [avaliacaoAdvertencia, setAvaliacaoAdvertencia] =   useState(flag === 0 ? "" : advertenciaAtualizar.avaliacao_advertencia);
 
    async function salvar() {


        try {

            if (!colaboradorSelecionado) {
                alert("Selecione o Responsável");
                return;
            }


           


            console.log("cadastrar chamado");
            const cadastro = {
                veiculo_id: veiculo.id_veiculo,
                tipo_advertencia: tipoAdvertencia,
                descricao_advertencia: descricao,
                responsavel: { id_colaborador: colaboradorSelecionado.id_colaborador },
                usuario_criador: { id_usuario: Cookies.get('id_usuario') },
                valor: parseFloat(valor),
                ocorrencias: ocorrenciasSelecionadas,
                rastreamentos: rastreamentosSelecionados,
                nota: nota,
                avaliacao_advertencia: avaliacaoAdvertencia,
            };

            if (dataAdvertencia && parse(dataAdvertencia, 'dd/MM/yyyy', new Date()) instanceof Date) {

                cadastro.data_advertencia = format(parse(dataAdvertencia, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd');
            } else {
                alert("Informe uma data válida!");
                return;
            }

            if (horaAdvertencia && parse(horaAdvertencia, 'HH:mm', new Date()) instanceof Date) {

                cadastro.hora_advertencia = format(parse(horaAdvertencia, 'HH:mm', new Date()), 'HH:mm');
            } else {
                alert("Informe uma hora válida!");
                return;
            }



            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.post('/v1/protected/veiculos/advertencias/cadastrar', cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                //closeNovaAdvertencia();
                //alert("Advertência Cadastrado!");
              setIdAdvertenciaSalva(cadastro_salvo.id_advertencia);


            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }



    }


    useEffect(() => {
        if (idAdvertenciaSalva > 0 && anexadorRef.current) {
            anexadorRef.current.salvarArquivos();
        }
    }, [idAdvertenciaSalva]);


    return (
        <>
            {!loading &&
                <Grid container spacing={2}   >
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        item xs={10}
                    >
                        <Button style={{ margin: 5 }}
                            variant="contained"
                            color="primary"
                            onClick={salvar}
                        > Salvar  </Button>
                    </Grid>

                    <Grid item xs={12}
                        container
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                        spacing={2}
                    >



                        <Grid item xs={3}>
                            <FormControl fullWidth>
                                <InputLabel id="status-ocorrencia-label">Tipo Advertência</InputLabel>
                                <Select
                                    labelId="status-ocorrencia-label"
                                    id="status-ocorrencia"
                                    value={tipoAdvertencia}
                                    onChange={(e) => setTipoAdvertencia(e.target.value)}
                                    label="Tipo Advertência"
                                >
                                    <MenuItem value={0}>Informativa</MenuItem>
                                    <MenuItem value={10}>Advertiva</MenuItem>
                                    <MenuItem value={20}>Penal</MenuItem>
                                 </Select>
                            </FormControl>
                        </Grid>


                         <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            align="center"
                            item xs={7}
                            style={{ marginTop: 5 }}
                        >
                            <Grid
                                container
                                direction="column"
                                justifyContent="center"
                                align="center"
                                item xs={12} >
                                <Autocomplete
                                    id="select-colaborador"
                                    options={colaboradores}
                                    disableCloseOnSelect
                                    getOptionLabel={(colaborador) => returnDescricaoColaborador(colaborador)}
                                    value={colaboradorSelecionado}
                                    onChange={(e, v) => handleSelecionarColaborador(v)}
                                    renderInput={(params) => (
                                        <TextField {...params} label=" Responsável "

                                            multiline
                                            minRows={3} />
                                    )}
                                />
                            </Grid>
                        </Grid>


                        {ocorrenciasFiltradas  && colaboradorSelecionado &&
                            <Grid
                                container
                                direction="row"
                                item xs={12}
                            >

                                <Grid item xs={12}  >
                                    <Autocomplete
                                        multiple
                                        id="ocorrencias"
                                        options={ocorrenciasFiltradas}
                                        getOptionLabel={(ocorrencia) => returnDescricaoOcorrenciaSimplificada(ocorrencia)}
                                        onChange={handleAdicionarOcorrencia}
                                        value={ocorrenciasSelecionadas}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Selecione as Ocorrências"
                                            />
                                        )}
                                        renderTags={(value, getTagProps) =>
                                            value.map((ocorrencia, index) => (
                                                <Chip
                                                    key={index}
                                                    label={returnDescricaoOcorrenciaSimplificada(ocorrencia)}
                                                    style={{
                                                        borderRadius: 15, // Borda arredondada
                                                        backgroundColor: '#e3f2fd', // Cor de fundo azul claro
                                                        margin: '4px', // Espaçamento entre as tags
                                                    }}
                                                    {...getTagProps({ index })}
                                                    onDelete={(event) => handleRemoverOcorrencia(event, ocorrencia)}

                                                />
                                            ))
                                        }
                                    />


                                </Grid>
                            </Grid>
                        }

                       
 {veiculo.rastreamentos  && colaboradorSelecionado &&
                            <Grid
                                container
                                direction="row"
                                item xs={12}
                            >

                                <Grid item xs={12}  >
                                    <Autocomplete
                                        multiple
                                        id="ras"
                                        options={veiculo.rastreamentos}
                                        getOptionLabel={(rastreamento) => returnDescricaoRastreamentoSimplificado(rastreamento)}
                                        onChange={handleAdicionarRastreamento}
                                        value={rastreamentosSelecionados}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Selecione as Viajens"
                                            />
                                        )}
                                        renderTags={(value, getTagProps) =>
                                            value.map((rastreamento, index) => (
                                                <Chip
                                                    key={index}
                                                    label={returnDescricaoRastreamentoSimplificado(rastreamento)}
                                                    style={{
                                                        borderRadius: 15, // Borda arredondada
                                                        backgroundColor: '#e3f2fd', // Cor de fundo azul claro
                                                        margin: '4px', // Espaçamento entre as tags
                                                    }}
                                                    {...getTagProps({ index })}
                                                    onDelete={(event) => handleRemoverRastreamento(event, rastreamento)}

                                                />
                                            ))
                                        }
                                    />


                                </Grid>
                            </Grid>
                        }


                       
 

                        <Grid item xs={12}
                            container
                            alignItems="center"
                            justifyContent="center"

                        >

                            <Grid item xs={3}
                                style={{ padding: 5 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="dataAdvertencia"
                                    label="Data da Identificação"
                                    id="dataAdvertencia"
                                    value={dataAdvertencia}
                                    onChange={(e) => setDataAdvertencia(e.target.value)}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={3}
                                style={{ padding: 5 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="horaAdvertencia"
                                    label="Hora da Identificação"
                                    id="horaAdvertencia"
                                    value={horaAdvertencia}
                                    onChange={(e) => setHoraAdvertencia(e.target.value)}
                                    fullWidth
                                />
                            </Grid>


                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                variant="standard"
                                name="descricao"
                                label="Descrição"
                                id="descricao"
                                value={descricao}
                                onChange={(e) => setDescricao(e.target.value)}
                                fullWidth
                                multiline
                                minRows={3}
                            />
                        </Grid>


                          <Grid item xs={12} style={{ padding: 2 }}
                                                                container
                                                                direction={'row'}
                                                                alignItems='center'
                                                                justifyContent='center'
                                                            >
                                                                <Box component="fieldset" mb={3} borderColor="transparent">
                                                                    <Rating
                                                                        name="simple-controlled"
                                                                        value={nota}
                                                                        onChange={handleChangeStart}
                                                                        precision={1}
                                                                        max={5}
                                                                        emptyIcon={<StarBorderIcon />}
                        
                                                                    />
                                                                </Box>
                                                            </Grid>

                                                            <Grid item xs={6} style={{ padding: 2 }}
                                                                                                    container
                                                                                                    direction={'row'}
                                                                                                    alignItems='center'
                                                                                                    justifyContent='center'
                                                                                                >
                                                                                                    <TextField
                                                                                                        variant="standard"
                                                                                                        name="avaliacaoAdvertencia"
                                                                                                        label="Avaliação"
                                                                                                        id="avaliacaoAdvertencia"
                                                                                                        value={avaliacaoAdvertencia}
                                                                                                        onChange={(e) => setAvaliacaoAdvertencia(e.target.value)}
                                                                                                        fullWidth
                                                                                                        multiline
                                                                                                        minRows={1}
                                                                                                    />
                                                                                                </Grid>



                    </Grid>


  <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        align="center"
                        item xs={12}
                        style={{ marginTop: 5 }}
                    >
                        <AnexadorArquivos
                            ref={anexadorRef}
                            flag={flag}
                            isAdvertencia={true}
                            objeto={flag === 1 ? advertenciaAtualizar : null}
                            id={flag === 1 ? advertenciaAtualizar.id_advertencia : idAdvertenciaSalva}
                            close={closeNovaAdvertencia}

                        />
                    </Grid>



                </Grid>
            }
        </>
    );
}


